<template>
  <div v-if="enabled && grid" :class="`position-${this.position}`" class="griddle bg-white top-0 left-0 w-100 h-100 pe-none opacity-25" style="height:100vh;z-index: 9999">
    <div v-if="false" class="position-absolute pb-6 bottom-0 end-0 text-center"><span class="p-0 btn border-info">{{ window.innerWidth }}x{{ window.innerHeight }}</span></div>
    <div :class="[container ?? 'container']" class="h-100 pe-none border border-black">
      <div class="row h-100 pe-none bg-info">
        <div data-name="overlay-column" v-for="n in 12" :key="n" class="col-1 col-sm-1 pe-none">
          <div class="h-100 text-center bg-info-subtle pe-none">
            <div class=" sticky-top">{{ n }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="enabled" class="waffle sticky-top fs-07 pe-auto btn-group border overflow-hidden bg-white shadow d-inline-flex align-items-center align-items-stretch">
    <div class="bg-agency text-white btn">
      <div class="d-inline-block d-sm-none">XS</div>
      <div class="d-none d-sm-inline-block d-md-none">SM</div>
      <div class="d-none d-md-inline-block d-lg-none">MD</div>
      <div class="d-none d-lg-inline-block d-xl-none">LG</div>
      <div class="d-none d-xl-inline-block d-xxl-none">XL</div>
      <div class="d-none d-xxl-inline-block">XXL</div>
    </div>
    <span class="btn" :class="{'fw-bold bg-success': grid}" @click.prevent.stop="grid=!grid">G</span>
    <span ref="rowcol" class="btn" :class="{'fw-bold bg-warning': rowcol, rowcol:rowcol}" @click.prevent.stop="toggleRowcol">RC</span>
    <span ref="marpad" class="btn" :class="{'fw-bold bg-info': marpad, marpad:marpad}" @click.prevent.stop="toggleMarpad">MP</span>
    <div v-if="false" class="text-center border-start d-flex">
      <label class="border border-nav px-1">
        <span class="d-block border-bottom border-component">fs</span>
        <span class="cursor-pointer" @click.stop="toggleFont(-1)">&#9853;</span>
      </label>
      <label v-for="size in [10,12,14,16,18,20,28,30,40]" :key="size" class="border border-nav px-1">
        <span class="d-block border-bottom border-component">{{size}}</span>
        <input class="cursor-pointer" type="checkbox" @click.stop="toggleFont(size)"/>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Griddle',
  props: {
    position: {
      type: String,
      default: 'absolute'
    },
    container: {
      type: String
    }
  },
  data() {
    return {
      enabled: false,
      grid: false,
      rowcol: false,
      marpad: false
    }
  },
  methods: {
    toggle() {
      if (this.enabled) {
        if (this.grid)
          this.grid = false;
        if (this.rowcol)
          this.toggleRowcol(false);
        if (this.marpad)
          this.toggleMarpad(false);
      }
      this.enabled = !this.enabled;
    },
    toggleRowcol() {
      this.rowcol = !this.rowcol;
      this.$refs.rowcol.closest('.waffle.modal,form,body').classList.toggle('rowcol');
    },
    toggleMarpad() {
      this.marpad = !this.marpad;
      this.$refs.marpad.closest('.waffle.modal,form,body').classList.toggle('marpad');
    },
    toggleFont(size) {
      if (size === -1)
        [...document.querySelectorAll('.rainbow')].forEach(q => q.classList.toggle('rainbow'));
      else
        [...this.$refs.marpad.closest('.waffle.modal,form,body').querySelectorAll(['', 'sm-', 'md-', 'lg-', 'xl-', 'xxl-'].map(s => '.fs-' + s + size).join(','))]
            .filter(el => Math.round(parseFloat(window.getComputedStyle(el, null).getPropertyValue('font-size'))) === size)
            .forEach(q => q.classList.toggle('rainbow'));
    }
  },
  mounted() {
    window.addEventListener('toggle-griddle', this.toggle);
    // this.toggleRowcol();
    // this.toggleMarpad();
  },
  unmounted() {
    window.removeEventListener('toggle-griddle', this.toggle);
  }
}
</script>
<style lang="scss">
.rowcol .row {
  border: 1px solid red;
}

.rowcol :is(.col, [class*='col-']) {
  border: 1px solid green;
}

/*TODO syam combine to tag for padding/border/margin highlight*/
.marpad * {
  :is([class*='p-'], [class*='ps-'], [class*='pe-'], [class*='pt-'], [class*='pb-'], [class*='px-'], [class*='py-']) {
    --margin-color: transparent;
    --padding-color: var(--bs-teal);
    --border-color: transparent;
    --content-color: white;
    background-color: var(--margin-color);
    background-image: linear-gradient(var(--content-color), var(--content-color)), linear-gradient(var(--padding-color), var(--padding-color));
    border-color: var(--border-color);
    background-clip: content-box, padding-box;
  }

  :is([class*='m-'], [class*='ms-'], [class*='me-'], [class*='mt-'], [class*='mb-'], [class*='mx-'], [class*='my-']) {
    --margin-color: var(--bs-yellow);
    --padding-color: transparent;
    --border-color: transparent;
    --content-color: white;
    background-color: var(--margin-color);
    background-image: linear-gradient(var(--content-color), var(--content-color)), linear-gradient(var(--padding-color), var(--padding-color));
    border-color: var(--border-color);
    background-clip: content-box, padding-box;
  }
}

.rainbow, .rainbow * {
  color: transparent!important;
}
</style>